import React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {
    formatDate,
    parseDate
} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import './CustomDateField.scss';

class CustomDateField extends React.Component {
    state = {
        value: this.props.value,
        error: false
    };

    onDayChange = (day, modifiers, dayPickerInput) => {
        const control = this.myInput;
        const input = dayPickerInput.getInput();
        const currentValue = input.value;
        // day parameter is only passed in when calendar picker is used, or if user types a complete date
        if (day) {
            const dateString = day === undefined ? null : day.toISOString();
            this.setState({ value: dateString, error: false }, () => {
                this.props.onChange(this.state.value);
                dayPickerInput.state.showOverlay = false;
            });
        } else {
            // if current value is blank/empty (which is valid), set bound field to undefined
            if (!currentValue) {
                this.setState({ value: undefined, error: false }, () => {
                    this.props.onChange(this.state.value);
                    dayPickerInput.state.showOverlay = false;
                });
            } else {
                // invalid date
                if (!this.state.error) {
                    this.setState({
                        error: true,
                        value: 'thisisanerror' // this is so that the date validation fails and doesn't just continue for non required fields
                    }, () => {
                        this.props.onChange(this.state.value);
                        setTimeout(() => { // will run after props onChange event fires
                            control.daypicker.dayPicker.focus();
                        }, 0);
                    });
                }
            }
        }
    };

    render() {
        const val = this.state.value ? formatDate(this.state.value) : '';
        const className = this.state.error ? 'date-picker-wrapper error' : 'date-picker-wrapper';

        return (
            <div className={className}>
                <DayPickerInput
                    ref={input => {
                        this.myInput = input;
                    }}
                    value={val}
                    className="form-control"
                    formatDate={formatDate}
                    placeholder={"MM/DD/YYYY"}
                    parseDate={parseDate}
                    onBlur={this.validateDate}
                    onDayChange={this.onDayChange}
                    onChange={e => this.onChange(e)}
                    disabled={this.props.disabled}
                    inputProps={{
                        required: this.props.required
                    }}
                />
            </div>
        );
    }
}

export default CustomDateField;